module.exports = __webpack_public_path__ + "img/brand-hangowear.dd12acb0.png";